import { Link } from 'react-router-dom';
import { mangaData } from '@/mocks/manga';

export default function LatestUpdates() {
  const latest = [...mangaData].sort(() => Math.random() - 0.5).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最近更新
            </h2>
            <p className="text-sm text-foreground-600">每日新鲜好漫，精彩不停歇</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5">
          {latest.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4]">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 dark:text-foreground-950 rounded-md">
                    {manga.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-3">
                  <span className="text-xs text-background-100">{manga.latestChapter}</span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{manga.updateTime}</p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 px-6 py-2.5 text-sm font-medium text-primary-600 bg-primary-50 rounded-full hover:bg-primary-100 transition-colors whitespace-nowrap"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}